(function () {
  if (window.__rtAnim) return;
  window.__rtAnim = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function count(el) {
    if (el.__rtDone) return;
    el.__rtDone = true;
    var to = parseFloat(el.getAttribute('data-rt-count'));
    if (reduce || isNaN(to)) return;
    var dur = 1500, t0 = null;
    el.textContent = '0';
    function step(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / dur, 1);
      var v = Math.round(to * (1 - Math.pow(1 - p, 3)));
      el.textContent = v.toLocaleString('fr-FR');
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function show(el) {
    el.setAttribute('data-rt-in', '');
    if (el.hasAttribute('data-rt-count')) count(el);
    el.querySelectorAll('[data-rt-count]').forEach(count);
  }

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { show(e.target); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' }) : null;

  function reveal(root) {
    (root || document).querySelectorAll('[data-rt-reveal]:not([data-rt-in])').forEach(function (el) {
      if (!io || reduce) { show(el); return; }
      io.observe(el);
    });
  }

  function tilt(root) {
    if (!fine || reduce) return;
    (root || document).querySelectorAll('[data-rt-tilt]:not([data-rt-tilt-on])').forEach(function (el) {
      el.setAttribute('data-rt-tilt-on', '');
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform = 'perspective(900px) rotateY(' + (x * 9) + 'deg) rotateX(' + (-y * 9) + 'deg)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }

  function progress(root) {
    (root || document).querySelectorAll('[data-rt-track]:not([data-rt-track-on])').forEach(function (track) {
      track.setAttribute('data-rt-track-on', '');
      var bar = track.parentNode.querySelector('[data-rt-bar]');
      if (!bar) return;
      function upd() {
        var max = track.scrollWidth - track.clientWidth;
        var ratio = max > 0 ? track.scrollLeft / max : 1;
        var visible = track.clientWidth / track.scrollWidth;
        bar.style.transform = 'translateX(' + (ratio * (1 - visible) * 100 / visible) + '%) scaleX(1)';
        bar.style.width = (visible * 100) + '%';
        bar.style.transform = 'translateX(' + (ratio * (100 - visible * 100) / visible) + '%)';
      }
      track.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    });
  }

  function faq(root) {
    (root || document).querySelectorAll('[data-rt-faq]:not([data-rt-faq-on])').forEach(function (wrap) {
      wrap.setAttribute('data-rt-faq-on', '');
      var items = wrap.querySelectorAll('.rt-faq__item');
      items.forEach(function (item) {
        var btn = item.querySelector('.rt-faq__q');
        btn.addEventListener('click', function () {
          var open = item.classList.contains('is-open');
          items.forEach(function (o) {
            o.classList.remove('is-open');
            o.querySelector('.rt-faq__q').setAttribute('aria-expanded', 'false');
          });
          if (!open) {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  }

  var par = [];
  function parallaxInit(root) {
    if (reduce) return;
    (root || document).querySelectorAll('[data-rt-parallax]:not([data-rt-par-on])').forEach(function (el) {
      el.setAttribute('data-rt-par-on', '');
      par.push(el);
    });
  }
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking || !par.length) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = window.pageYOffset;
      par.forEach(function (el) {
        el.style.transform = 'translate3d(0,' + (y * parseFloat(el.getAttribute('data-rt-parallax')) * -1) + 'px,0)';
      });
      ticking = false;
    });
  }, { passive: true });

  function init(root) {
    reveal(root); tilt(root); progress(root); faq(root); parallaxInit(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
